import type { SearchLocation } from 'modules/search/types/SearchLocation';

import { isLocationEmpty } from './searchIsLocationEmpty';

// @NOTE: `hasGeo` is used to determine whether a search location
// should be empty or not when saved to the DB, if it is `true`,
// the backend deletes the properties in `location`, essentially
// making it into an empty search location
//
// This may be better handled when setting the search location via the `LocationField` and adding hasGeo: true to `guessedLocation`
export const searchAddHasGeoToSearchLocation = (
  searchLocation: SearchLocation,
) =>
  isLocationEmpty(searchLocation)
    ? { ...searchLocation, hasGeo: false }
    : { ...searchLocation, hasGeo: true };
